<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <el-form-item label="流水单号">
          <el-input v-model="fundBillNo" clearable style='width:200px;' placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态" style="margin-left: 20px;">
          <el-select v-model="transStatus" clearable style='width:200px;' placeholder="请选择">
            <el-option v-for="(item, index) in transStatusOptions" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发起日期" span="2" style="margin-left: 20px;">
          <el-date-picker
            v-model="startDate"
            clearable
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker
            style="margin-right: 15px;"
            v-model="endDate"
            clearable
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 10px;">
          <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <el-table ref="zTable" :data="tableData">
      <el-table-column prop="fundBillNo" label="流水单号" align="center"></el-table-column>
      <el-table-column prop="" label="变动类型" :formatter="transType" align="center"></el-table-column>
      <el-table-column prop="occurBalance" label="金额（元）" align="center">
        <template slot-scope="scope">
          <span>
            {{scope.row.occurBalance | thousandMark}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="subBankAccount" label="附属账号" align="center"></el-table-column>
      <el-table-column prop="bankAccount" label="对方账号" align="center"></el-table-column>
      <el-table-column prop="" label="交易状态" :formatter="status" align="center"></el-table-column>
      <el-table-column prop="gmtCreate" label="发起时间" align="center"></el-table-column>
      <!-- <el-table-column prop="gmtModify" label="支付时间" align="center" :show-overflow-tooltip="true"></el-table-column> -->
    </el-table>
    <el-pagination
      class="pagination"
      layout='total, prev, pager, next'
      :current-page.sync="currentPage"
      :total='total'
      @current-change="changePage"
      background>
    </el-pagination>
  </div>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/util'
export default {
  name: 'sugar-access-money',
  components: {
  },
  data () {
    return {
      // 列表信息
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      // 流水单号
      fundBillNo: '',
      // 出入金类型
      payWay: '',
      // 发起日期
      startDate: '',
      endDate: '',

      // 状态
      transStatus: '',
      transStatusOptions: [{
        id: '0',
        name: '未报'
      }, {
        id: '1',
        name: '已报'
      }, {
        id: '2',
        name: '成功'
      }, {
        id: '3',
        name: '失败'
      }],
    }
  },
  mounted () {
    this.fetchList(1, 10)
  },
  methods: {
    // 查询
    handleSearch () {
      this.fetchList(1, 10)
    },
    // 重置
    handleReset () {
      this.fundBillNo = ''
      this.payWay = ''
      this.transStatus = ''
      this.startDate = ''
      this.endDate = ''
      this.fetchList(1, 10)
    },
    // 获取列表数据
    fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        marketId: '000',
        startDate: formatTime(this, this.startDate).substring(0, 10),
        endDate: formatTime(this, this.endDate, 1).substring(0, 10),
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        fundBillNo: this.fundBillNo,
        transStatus: this.transStatus,
        transTypeList: ['30010100', '30020100']

      }
      api.myAccount.hkList(param).then((res) => {
        this.tableData = res.data.rows
        this.total = res.data.totalElements
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 交易状态
    transactionStatus () {
    },
    // 出入金状态
    status (row) {
      if (row.transStatus === '0') {
        return '未报'
      } else if (row.transStatus === '1') {
        return '已报'
      } else if (row.transStatus === '2') {
        return '成功'
      } else if (row.transStatus === '3') {
        return '失败'
      } else {
        return '/'
      }
    },
    // 变动类型
    transType (row) {
      if (row.transType === '10000102') {
        return '签约'
      } else if (row.transType === '01990800') {
        return '解约'
      } else if (row.transType === '01990300') {
        return '提现'
      } else if (row.transType === '01990100') {
        return '货款入金'
      } else if (row.transType === '01990200') {
        return '支付货款'
      } else if (row.transType === '30010100') {
        return '银行诚意金划入'
      } else if (row.transType === '30020100') {
        return '银行诚意金划出'
      } else if (row.transType === '01990700') {
        return '修改附属账户名称'
      } else {
        return '/'
      }
    },
    // 支付时间
    payTime (row) {
      return row.recDate + ' ' + row.recTime
    },
    // 关闭弹窗
    handleClose () {
      this.isSugerOperation = false
    },
    // 分页
    changePage (page) {
      this.fetchList(page)
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .table-page-search-submitButtons{
    margin-left: 100px
  }
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
</style>
